import { useCampaignSlug } from '@/lib/useCampaignSlug'
import styles from '@/styles/Home.module.scss'
import { useRouter } from 'next/router'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

type StampComponentsType = {
  query: number
  hasCount: number
  course: string | string[]
  img: string | null
  name: string
  spots: [
    {
      address: string
      id: number
      name: string
      zip: string
    },
  ]
  isRepeatStamp: boolean
  stampShape: 'circular' | 'square'
  onGroupModal: () => void
}

export const StampComponents = memo(
  ({ query, hasCount, img, name, spots, isRepeatStamp, stampShape, onGroupModal }: StampComponentsType) => {
    const router = useRouter()
    const { t } = useTranslation()
    const { gen } = useCampaignSlug()

    return (
      <>
        <button
          type="button"
          className={`flex flex-col items-center justify-center ${styles.c_stamp}`}
          onClick={() => {
            spots.length > 1
              ? onGroupModal()
              : router.push({
                  pathname: gen('/spot/detail/'),
                  query: { query: query },
                })
          }}
        >
          <div className={`${styles.c_stamp_img} ${styles[stampShape] || ''}`}>
            <img src={img} alt="" />
          </div>
          {isRepeatStamp && (
            <div className="mt-2 flex min-w-[75px] items-center justify-between break-words break-all rounded-[4px] bg-main px-1 text-xss text-sub">
              <p>{t('home.you_got', '獲得数')}:</p>
              <p>{`${hasCount >= 100 ? '99+' : hasCount}`}</p>
            </div>
          )}

          <p className="mt-1 break-words break-all text-sm">{name}</p>
        </button>
      </>
    )
  },
)
